import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function Pricing() {
  return <section id="precio" className="w-full bg-cream py-20 sm:py-28" aria-labelledby="precio-title" data-id="element-77" data-mp="2aq9b1iwwod7n">
      <div className="mx-auto max-w-3xl px-6 text-center lg:px-8" data-id="element-78" data-mp="2ohxn5m75n1om">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="rounded-[2rem] border border-gold/25 bg-ivory px-8 py-14 sm:px-14" data-id="element-79" data-mp="2jknqblhfrnqr">
          <p className="font-sans text-xs uppercase tracking-[0.28em] text-gold-deep" data-id="element-80" data-mp="25tsq0xl06eys">
            Precio de lanzamiento
          </p>

          <h2 id="precio-title" className="mt-5 font-serif text-3xl leading-tight text-ink sm:text-4xl" data-id="element-81" data-mp="20vhdgf3bpqcv">
            Tu guía completa, hoy
          </h2>

          <div className="mt-8 flex items-end justify-center gap-4" data-id="element-82" data-mp="3caeaoc9nvlvb">
            <span className="font-sans text-xl text-ink-light line-through" data-id="element-83" data-mp="3vyx9y77z6ciq">
              $10
            </span>
            <span className="font-serif text-6xl leading-none text-ink sm:text-7xl" data-id="element-84" data-mp="4rb1m1ab9lvj">
              $5
            </span>
          </div>

          <p className="mt-5 font-sans text-[15px] text-ink-soft" data-id="element-85" data-mp="er1wi42sa2w5">
            Pago único. Sin suscripciones. Tuya para siempre.
          </p>

          <div className="mt-10" data-id="element-86" data-mp="3daa9k20qubbh">
            <CtaButton href="#precio" className="w-full sm:w-auto" data-id="element-87" data-mp="3d74i4g4n6xcl">
              Quiero sanar mi relación con el miedo
            </CtaButton>
          </div>

          <p className="mt-6 font-sans text-sm text-ink-light" data-id="element-88" data-mp="3n6d86xwdzrto">
            Recibes el PDF en tu correo al instante.
          </p>
        </motion.div>
      </div>
    </section>;
}